import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import './SchedulePost.css'

interface SchedulePostProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
}

const SchedulePost: React.FC<SchedulePostProps> = ({ selectedDate, onDateChange }) => {
  const { t } = useTranslation();

  const months = [
    t('January'), t('February'), t('March'), t('April'), t('May'), t('June'),
    t('July'), t('August'), t('September'), t('October'), t('November'), t('December')
  ];

  const daysInMonth = dayjs(selectedDate).daysInMonth();
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const month = months.indexOf(event.target.value);
    const newDate = dayjs(selectedDate).month(month).toDate();
    onDateChange(newDate);
  };

  const handleDayChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const day = parseInt(event.target.value, 10);
    const newDate = dayjs(selectedDate).date(day).toDate();
    onDateChange(newDate);
  };

  const handleHourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const hour = parseInt(event.target.value, 10);
    const newDate = dayjs(selectedDate).hour(hour).toDate();
    onDateChange(newDate);
  };

  const handleMinuteChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const minute = parseInt(event.target.value, 10);
    // Forzar una nueva instancia de Date incluso si el minuto es el mismo
    const newDate = dayjs(selectedDate).minute(minute).second(0).millisecond(0).toDate();
    console.log('Minute change:', {
      selectedValue: event.target.value,
      parsedMinute: minute,
      originalDate: selectedDate,
      newDate: newDate
    });
    onDateChange(newDate);
  };

  const padTime = (time: number) => time.toString().padStart(2, '0');

  return (
    <div className="schedule-post-container">
      <label>{t('Selecciona cuándo quieres publicar')}:</label>
      <div className="schedule-selectors">
        <div className="schedule-time">
          <div className="schedule-letter">{t('Mes')}</div>
          <div>
            <select value={months[selectedDate.getMonth()]} onChange={handleMonthChange}>
              {months.map((month, index) => (
                <option key={index} value={month}>
                  {t(month)}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="schedule-time">
          <div className="schedule-letter">{t('Día')}</div>
          <div>
            <select value={selectedDate.getDate()} onChange={handleDayChange}>
              {days.map((dayNumber) => (
                <option key={dayNumber} value={dayNumber}>
                  {dayNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="schedule-time">
          <div className="schedule-letter">{t('Hora')}</div>
          <div>
            <select value={padTime(selectedDate.getHours())} onChange={handleHourChange}>
              {hours.map((hour) => (
                <option key={hour} value={padTime(hour)}>
                  {padTime(hour)}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="schedule-time">
          <div className="schedule-letter">{t('Minuto')}</div>
          <div>
            <select value={padTime(selectedDate.getMinutes())} onChange={handleMinuteChange}>
              {minutes.map((minute) => (
                <option key={minute} value={padTime(minute)}>
                  {padTime(minute)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePost;
